module.exports = __webpack_public_path__ + "bf6942fef58d6600c12706d0549176e5.MP3";